// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportActions_root__6h0FT","button":"ReportActions_button__1ZA1I","icon":"ReportActions_icon__pfdNN"};